(function () {
    angular.module('tradersyard').component('tyWebinarWidget', {
        // language=HTML
        template: `
            <div class="card upcoming-event-item" ng-if="$ctrl.webinar">
                <div class="upcoming-event-item-top">
                    <div class="upcoming-event-item-top-owner-picture">
                        <a ng-href="/{{$ctrl.webinar.owner.id}}"
                           title="{{$ctrl.webinar.owner.name}}"
                           open-authentication-dialog
                        >
                            <img ng-src="{{$ctrl.webinar.owner.picture.source|thumb:50:50}}" alt="{{$ctrl.webinar.owner.name}}">
                        </a>
                    </div>

                    <div class="upcoming-event-item-top-content">
                        <a class="bold"
                           ng-if="$ctrl.isAuthorized"
                           ng-bind="$ctrl.webinar.owner.name"
                           ng-href="/{{$ctrl.webinar.owner.id}}"
                           title="{{$ctrl.webinar.owner.name}}"
                        ></a>
                       
                        <a open-authentication-dialog
                           ng-if="!$ctrl.isAuthorized"
                           class="bold"
                           ng-bind="$ctrl.webinar.owner.name"
                           ng-href="/{{$ctrl.webinar.owner.id}}"
                           title="{{$ctrl.webinar.owner.name}}"
                        ></a>
                        <div class="upcoming-event-item-top-content-time-of">
                            <span ng-bind="$ctrl.webinar.started_at|moment:'L LT'"></span>
                        </div>
                    </div>
                </div>
                <div class="upcoming-event-item-countdown-timer">
                    <ty-countdown-timer
                        countdown-time="$ctrl.webinar.started_at"
                    />
                </div>

                <div class="upcoming-event-item-middle">
                    <img height="80" ng-src="{{$ctrl.webinar.picture.source|thumb:400:200}}" alt="{{$ctrl.webinar.name}}"/>

                    <div class="upcoming-event-item-middle-content">
                        <div class="upcoming-event-item-middle-content-languages">
                            <div ng-repeat="language in $ctrl.webinar.languages"
                                 class="upcoming-event-item-middle-content-language-item">
                                <img ng-src="{{language.logo}}" title="{{language.name}}"/>
                            </div>
                        </div>

                        <div class="upcoming-event-item-middle-content-rating"
                             popover
                             popover-template="rating_webinar"
                             popover-placement="right"
                             popover-trigger="mouseover"
                             popover-theme="popover-tooltip-theme"
                        >
                            <span class="upcoming-event-item-middle-content-rating"
                                  ng-bind="$ctrl.webinar.rating | humanizeRating"
                            ></span>
                        </div>
                    </div>
                </div>

                <div class="upcoming-event-item-bottom">
                    <div class="upcoming-event-item-bottom-content">
                        <a class="bold" ng-bind="$ctrl.webinar.name" ng-href="/webinar/{{$ctrl.webinar.id}}"
                           title="{{$ctrl.webinar.name}}"></a>
                    </div>

                    <div class="upcoming-event-item-bottom-action">
                        <div open-authentication-dialog
                             open-authentication-dialog-condition="!$ctrl.isAuthorized"
                             class="upcoming-event-item-bottom-action-like"
                        >
                            <span open-authentication-dialog
                                  class="like form"
                                  like-form
                                  active-class="active"
                                  entry="'user'"
                                  entry-id="$ctrl.webinar.id"
                                  entry-im="$ctrl.webinar.im_like"
                                  entry-count="$ctrl.webinar.likes"
                                  title="Recommend {{$ctrl.webinar.name}} to TradersYard community"
                            >
                                <span ng-bind="$ctrl.webinar.likes"></span>
                                <span class="icon-yard-like"></span>
                            </span>
                            
                            <span class="upcoming-event-item-bottom-action-like" ng-bind="$ctrl.webinar.likes"></span>

                            <a ng-click="openRecurringDates($ctrl.webinar)"
                               ng-show="$ctrl.webinar.executions && $ctrl.webinar.executions.length > 1"
                               style="padding-left: 12px;"
                            >
                                <span class="icon-yard-menu" title="It's recurring webinar. Click to see future dates."></span>
                                Recurring
                            </a>
                        </div>

                        <div class="upcoming-event-item-bottom-action-status">
                            <span class="icon-yard-stat-regist"></span>
                            <span class="upcoming-event-item-bottom-action-status"
                                  ng-if="$ctrl.webinar.status"
                                  ng-bind="$ctrl.webinar.status | ucFirst"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        `,
        bindings: {
            webinar: '<',
            isAuthorized: '<',
        },
        transclude: true,
        controller: WebinarWidgetCtrl,
    });

    WebinarWidgetCtrl.$inject = ['$scope'];

    function WebinarWidgetCtrl($scope) {
        const ctrl = this;

        ctrl.$onInit = function () {};
    }
})();
